<script setup lang="ts">
// COMPOSABLES
const { isMobile } = useResponsive();
const { tt } = useTypedI18n();

// PROPS
interface Props {
    salesContact?: SalesContact;
    guideTo?: string;
}

defineProps<Props>();

// MODEL
const isModalOpen = defineModel<boolean>('open', { required: true });

// DATA
const salesContactFormModalState = useModalState<boolean>();
</script>

<template>
    <UModal
        v-model:open="isModalOpen"
        :fullscreen="isMobile"
        :title="tt('vas.FleequidCare.infoModal.title')"
        :ui="{ content: 'max-w-2xl' }"
        v-bind="modalNoDescAriaFixupProps"
    >
        <slot />

        <template #body>
            <div class="space-y-4">
                <p>{{ tt('vas.FleequidCare.infoModal.description') }}</p>

                <p>
                    <span class="font-semibold">{{ tt('vas.FleequidCare.infoModal.protectionDuration.title') }}:</span>
                    {{ tt('vas.FleequidCare.infoModal.protectionDuration.value') }}
                </p>

                <p>
                    <span class="font-semibold">{{ tt('vas.FleequidCare.infoModal.maxCoverage.title') }}:</span>
                    {{ tt('vas.FleequidCare.infoModal.maxCoverage.value') }}
                </p>

                <div class="space-y-2">
                    <p class="font-semibold">{{ tt('vas.FleequidCare.infoModal.coveredComponents.title') }}:</p>

                    <ul class="list-disc space-y-2 pl-5">
                        <li>
                            <span class="font-medium">{{ tt('vas.FleequidCare.infoModal.engine.title') }}:</span><br />
                            <span class="text-muted text-sm"> {{ tt('vas.FleequidCare.infoModal.engine.description') }}</span>
                        </li>
                        <li>
                            <span class="font-medium">{{ tt('vas.FleequidCare.infoModal.gearbox.title') }}:</span><br />
                            <span class="text-muted text-sm"> {{ tt('vas.FleequidCare.infoModal.gearbox.description') }}</span>
                        </li>
                    </ul>
                </div>

                <BaseI18nT v-if="guideTo" tag="p" keypath="vas.FleequidCare.infoModal.moreInfo.base">
                    <template #link>
                        <NuxtLink class="text-primary underline" :to="guideTo" target="_blank">
                            {{ tt('vas.FleequidCare.infoModal.moreInfo.link') }}
                        </NuxtLink>
                    </template>
                </BaseI18nT>

                <SalesContactCard v-if="salesContact" :sales-contact="salesContact" @open-contact-form="salesContactFormModalState.open()" />
            </div>
        </template>
    </UModal>

    <SalesContactFormModal
        v-if="salesContact"
        v-model="salesContactFormModalState.isOpen"
        :sales-contact="salesContact"
        @success="salesContactFormModalState.confirm(true)"
    />
</template>
